import { Box, Grid, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const RouteProgressDedicatedDashboard = () => {
  const navigate = useNavigate();

  const handleClick = (clientId: number) => {
    navigate({
      pathname: `/route-progress-dedicated-overview`,
      search: `client_id=${clientId}`,
    });
  };

  return (
    <Box p={2}>
      <Grid container spacing={2}>
        {[
          {
            clientId: 132,
            clientName: "Target",
          },
        ].map((e) => (
          <Grid item xs={3} key={e.clientId}>
            <Paper
              elevation={3}
              onClick={() => handleClick(e.clientId)}
              sx={{
                height: 100,
                display: "flex",
                cursor: "pointer",
                transition: "background-color 0.3s",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#d3f9d8",
                "&:hover": {
                  backgroundColor: "green",
                  color: "white",
                },
              }}
            >
              <Typography align="center" component="h3" variant="h4">
                {e.clientName}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RouteProgressDedicatedDashboard;
